import { Icon } from "./MenuIcon.styles";

type MenuIconProps = {
    isOpen: boolean;
};

const MenuIcon = ({ isOpen }: MenuIconProps) => {
    return (
        <Icon isOpen={isOpen}>
            <span />
            <span />
            <span />
        </Icon>
    );
};

export default MenuIcon;
